<template>
    <v-dialog
        :title="'管理【' + roleName + '】角色下的员工'"
        :open="value"
        @close="close()"
    >
        <div class="admin-col-container">
            <div class="admin-col-optbar">
                <v-button
                    @click="showSelectDialog"
                    status="primary"
                >
                    <v-icon name="new" />添加员工
                </v-button>
                <staff-select-dialog
                    ref="selectDialog"
                    @confirm="onSelectedConfirm"
                />
                <v-input
                    v-model="searchText"
                    :disabled="empty"
                    :placeholder="searchPlaceHolder"
                    @search="search"
                    style="float:right"
                    name="product"
                    kind="search"
                />
            </div>
            <div
                @scroll.capture="onscroll"
                style="margin-top:16px;"
                class="memlist"
            >
                <v-table
                    :loading="loading1"
                    :data="data"
                    :header-fix="true"
                    :row-clazz="initRowClass"
                >
                    <v-table-column
                        :width="252"
                        column-key="name"
                        label="姓名(账号名)"
                    >
                        <template
                            slot="cell"
                            slot-scope="props"
                        >
                            <v-tip
                                :ref="'name' + props.row.id"
                                placement="top"
                            >
                                <span>{{ props.row.exceedLimit ? '您没有管理该员工的权限' : props.row.name }}</span>
                            </v-tip>
                            <span
                                v-tip.hover="'name' + props.row.id"
                                v-html="highlight(props)"
                            />
                        </template>
                    </v-table-column>
                    <v-table-column
                        v-if="needQQ"
                        :width="132"
                        column-key="qq"
                        label="QQ员工号"
                    >
                        <template
                            slot="cell"
                            slot-scope="props"
                        >
                            <v-tip
                                :ref="'id' + props.row.id"
                                placement="top"
                            >
                                <span>{{ props.row.exceedLimit ? '您没有管理该员工的权限' : props.row.qq }}</span>
                            </v-tip>
                            <span
                                v-tip.hover="'id' + props.row.id"
                                v-html="highlight(props)"
                            />
                        </template>
                    </v-table-column>
                    <v-table-column
                        :width="192"
                        column-key="department"
                        label="部门"
                    >
                        <template
                            slot="cell"
                            slot-scope="props"
                        >
                            <v-tip
                                :ref="'department' + props.row.id"
                                placement="top"
                            >
                                <span style="max-width: 600px;">{{
                                    props.row.exceedLimit ? '您没有管理该员工的权限' : props.row.departments
                                }}</span>
                            </v-tip>
                            <div
                                v-tip.hover="'department' + props.row.id"
                                class="table-cell"
                            >
                                {{ props.row.departments }}
                            </div>
                        </template>
                    </v-table-column>
                    <v-table-column
                        :width="18"
                        align="left"
                    >
                        <template
                            slot="cell"
                            slot-scope="props"
                        >
                            <template v-if="props.row.exceedLimit">
                                <a
                                    class="table-delete"
                                    style="cursor: no-drop;"
                                >删除</a>
                            </template>
                            <template v-else>
                                <v-popconfirm
                                    :ref="'del' + props.row.id"
                                    @confirm="rmColleageu(props.row)"
                                    status="warning"
                                    placement="top-end"
                                >
                                    <p style="max-width: 208px;margin: auto;">
                                        移除后，该员工将失去【{{ roleName }}】角色
                                    </p>
                                    <span slot="confirm-text">移除</span>
                                </v-popconfirm>
                                <a
                                    v-popconfirm="'del' + props.row.id"
                                    class="table-delete"
                                >删除</a>
                            </template>
                        </template>
                    </v-table-column>
                    <template slot="nodata">
                        <div v-if="empty">
                            <div class="memlist_empty" />
                            <p style="font-size: 16px;color: #1E2330;">
                                暂无员工
                            </p>
                        </div>
                        <div v-else>
                            <div class="search_empty" />
                            <p style="font-size: 16px;color: #1E2330;">
                                没有符合条件的员工
                            </p>
                        </div>
                    </template>
                </v-table>
                <v-spinner
                    v-show="loading2"
                    :opacity="0.5"
                    size="large"
                />
            </div>
        </div>
        <v-dialog
            v-model="showQQNoMoreDlg"
            title="QQ员工号配额不足"
            kind="alert"
        >
            <div>当前剩余 5 个可用的QQ员工号，请减少要添加的员工数</div>
            <div>或等待删除中的QQ员工号释放、将不需要沟通能力的QQ员工号收回</div>
        </v-dialog>
    </v-dialog>
</template>

<script>
import { isInAccountComplete } from 'src/cgi/getWhiteList';
import { hasQQChannel } from 'src/cgi/getKfuinChannels';
import terminalPriCheck from 'src/cgi/terminalPriCheck';
import StaffSelectDialog from './staff-select-dialog';

export default {
    components: {
        StaffSelectDialog,
    },

    props: {
        value: {
            type: Boolean,
            default: false,
        },
        roleName: {
            type: String,
            default: '',
        },
        roleId: {
            type: Number,
            default: -1,
        },
        isXTRole: {
            type: Boolean,
            default: false,
        },

        roleData: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    data() {
        return {
            pageNum: 1,
            pageSize: 50,
            empty: false, // 员工列表是否为空
            data: [],
            totalNum: 0,
            loading1: false, // 产品说表格里没有数据的时候用这个loading
            loading2: false, // 产中说表格里有数据的时候用这个loading
            searchMode: false, // 当前列表是否由搜索产生
            searchText: '', // 搜索文本
            showRemove: false, // 删除角色框
            addBtnDisable: false, // 添加按钮禁用态防止快速点击多次触发
            showQQNoMoreDlg: false,
            needQQ: true,
            selectedMemberList: [],
            accountCompleteTag: false,
        };
    },

    computed: {
        searchPlaceHolder() {
            let placeholder = '员工姓名/账号名';

            if (this.needQQ) {
                placeholder = `${placeholder}/QQ员工号`;
            }

            return placeholder;
        },

        // 是否要显示QQ相关提示
        showQQTip() {
            return this.roleData.hasQQPrivilege && this.needQQ && this.accountCompleteTag;
        },
    },

    watch: {
        value: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.initList();
                }
            },
        },
    },

    created() {
        // 判断是否有完整的新账号功能
        isInAccountComplete().then((val) => {
            this.accountCompleteTag = val;
        });

        hasQQChannel().then((val) => {
            this.needQQ = val;
        });
    },
    methods: {
        showSelectDialog() {
            this.$refs.selectDialog.show({
                showQQTip: this.showQQTip,
                roleId: this.roleId,
            });
        },

        initRowClass(row) {
            // console.log(row, index);
            return row.exceedLimit ? 'admin-table-disabled-row' : '';
        },
        initList() {
            this.pageNum = 1;
            this.totalNum = 0;
            this.data = [];
            if (this.searchMode) {
                this.queryUserList();
            } else {
                this.fetchKfextList();
            }
        },
        highlight(props) {
            let html = props.row[props.column.columnKey];
            if (html && this.searchMode) {
                html = html.replace(new RegExp(this.searchText, 'ig'), '<span class="highlight">$&</span>');
            }
            return html;
        },
        close() {
            this.$emit('input', false);
            this.empty = false;
            this.searchMode = false;
            this.searchText = '';
        },
        onscroll(event) {
            const ele = event.target;
            if (ele.clientHeight + ele.scrollTop >= ele.scrollHeight) {
                // 滚动到最后时就加载下一页数据
                if (this.searchMode) {
                    this.queryUserList();
                } else {
                    this.fetchKfextList();
                }
            }
        },
        search() {
            if (this.empty) return;
            if (this.searchText) {
                this.searchMode = true;
            } else {
                this.searchMode = false;
            }
            this.initList();
        },
        rmColleageu(data) {
            const reqData = {
                roleID: this.roleId,
                memID: data.id,
            };

            terminalPriCheck('delCol', reqData, () => {
                this.$ajax.write('/mng/role/delCol', reqData).then(
                    (res) => {
                        const { code, message } = res || {};
                        if (parseInt(code, 10) === 0) {
                            this.$message.success('移除成功');
                            this.initList(); // 删除员工后重新拉列表
                            this.$emit('remove');
                        } else {
                            this.$message.error(message || '删除角色失败，请稍后重试');
                        }
                    },
                    (error) => {
                        this.$message.error(error && error.message);
                    },
                );
            });
        },

        onSelectedConfirm(dataList, e) {
            e.preventDefault();
            if (dataList && dataList.length > 0) {
                this.selectedMemberList = dataList.map(item => item.id);
                this.addMember();
            }
        },
        customMsg(res) {
            this.$refs.selectDialog?.hideConfirmLoading();
            this.$message.error(res.message || '员工添加角色失败');
        },
        addMember() {
            const { selectDialog } = this.$refs;
            const reqData = {
                roleid: this.roleId,
                memary: this.selectedMemberList,
            };

            selectDialog.showConfirmLoading();

            terminalPriCheck(
                'addUser',
                reqData,
                () => {
                    this.$ajax.write('/mng/role/addUser', reqData, { customFn: this.customMsg }).then(
                        (res) => {
                            const { code, message } = res || {};
                            if (parseInt(code, 10) === 0) {
                                this.$message.success('员工添加角色成功');
                                this.initList(); // 添加员工后重新拉列表
                                this.$emit('add');
                                selectDialog.hide();
                            } else {
                                this.$message.error(message || '员工添加角色失败');
                            }

                            selectDialog.hideConfirmLoading();
                        },
                        (error) => {
                            this.$message.error((error && error.message) || '员工添加角色失败');
                            selectDialog.hideConfirmLoading();
                        },
                    );
                },
                () => {
                    selectDialog.hideConfirmLoading();
                },
            );
        },
        // 格式化部门信息
        formatDepartments(departments) {
            if (Array.isArray(departments) && departments.length > 0) {
                // 遍历每个部门，提取 dep_names 并合并成一个字符串
                const formattedDepartments = departments.map(dept => {
                    if (Array.isArray(dept.dep_names)) {
                        const reversedDepNames = dept.dep_names.reverse();
                        return reversedDepNames.join('/');
                    }
                return '';
                });
                // 将每个部门的字符串用逗号隔开
                return formattedDepartments.join(', ');
            }
            return '';
        },
        fetchKfextList() {
            if (this.pageNum >= 2 && this.data.length >= this.totalNum) {
                return;
            }
            if (this.loading1 || this.loading2) return;
            if (this.data.length > 0) {
                this.loading2 = true;
            } else {
                this.loading1 = true;
            }

            this.$ajax
                .write('/mng/role/kfextListByRoleId', {
                    roleId: this.roleId, // 角色ID
                    pageSize: this.pageSize, // 分页的数量
                    pageNum: this.pageNum, // 页码
                })
                .then(
                    (res) => {
                        const { code, data, message } = res || {};
                        if (parseInt(code, 10) === 0) {
                            const totalNum = parseInt(res.totalNum, 10);
                            const kfList = data.map(({ id, qq, name, ename, cname, department, exceedLimit, departments }) => ({
                                id,
                                qq: qq || '-',
                                name,
                                ename,
                                cname,
                                department,
                                exceedLimit,
                                departments:this.formatDepartments(departments),
                            }));
                            
                            if (kfList && kfList.length > 0) {
                                this.data = this.data.concat(kfList);
                                this.totalNum = totalNum;
                                this.empty = false;
                                this.pageNum = this.pageNum + 1;
                            } else if (this.pageNum === 1) {
                                this.empty = true;
                            }

                            this.loading1 = false;
                            this.loading2 = false;
                        } else {
                            this.$message.error(message || '请求失败，请稍后重试');
                        }
                    },

                    (error) => {
                        this.$message.error((error && error.message) || '请求失败，请稍后重试');
                    },
                );
        },
        customFn(res) {
            this.loading1 = false;
            this.loading2 = false;
            this.$message.error(res?.message || '查询失败，请稍后重试');
        },
        queryUserList() {
            if (this.pageNum >= 2 && this.data.length >= this.totalNum) {
                return;
            }
            if (this.loading1 || this.loading2) return;
            if (this.data.length > 0) {
                this.loading2 = true;
            } else {
                this.loading1 = true;
            }

            this.$ajax
                .write('/mng/role/queryUserInfo', {
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                    roleId: this.roleId,
                    searchText: this.searchText,
                }, { customFn: this.customFn })
                .then(
                    (res) => {
                        const { code, data, message } = res || {};
                        if (parseInt(code, 10) === 0) {
                            const totalNum = parseInt(res.totalNum, 10);
                            const kfList = data.map(({ id, qq, name, ename, cname, department, exceedLimit, departments }) => ({
                                id,
                                qq: qq || '-',
                                name,
                                ename,
                                cname,
                                department,
                                exceedLimit,
                                departments:this.formatDepartments(departments),
                            }));

                            if (kfList && kfList.length > 0) {
                                this.data = this.data.concat(kfList);
                                this.totalNum = totalNum;
                                this.pageNum = this.pageNum + 1;
                            }
                            this.loading1 = false;
                            this.loading2 = false;
                        } else {
                            this.$message.error(message || '查询失败，请稍后重试');
                        }
                    },

                    (error) => {
                        this.$message.error((error && error.message) || '请求失败，请稍后重试');
                    },
                );
        },
    },
};
</script>

<style lang="less">
@import './index.less';
</style>
